var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-textarea',_vm._g(_vm._b({ref:"input",nativeOn:{"input":function($event){return _vm.onInput.apply(null, arguments)}}},'v-textarea',_vm.attributes,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }